import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { FlexContainer } from '@act/storybook';
import { removeHtmlTags } from '@act/shared/utilities';
import { themeColors } from 'toolkit/styles/colors';

const PREVIEW_MAX_CHARS = 160;

export interface NotePreviewCardProps {
  /** Note HTML to preview (rendered as truncated plain text). */
  text: string;
}

/**
 * Compact, read-only preview of a note's text — used in the draft-recovery
 * modal so the user can recognize the note before continuing or discarding.
 */
const NotePreviewCard = ({ text }: NotePreviewCardProps): ReactElement => {
  const plain = removeHtmlTags(text).trim();
  const preview =
    plain.length > PREVIEW_MAX_CHARS
      ? `${plain.slice(0, PREVIEW_MAX_CHARS)}…`
      : plain;

  return (
    <FlexContainer
      direction="column"
      gap={0.5}
      padding={2}
      width="100%"
      height="fit-content"
      borderRadius="slightlyRounded"
      backgroundColor={themeColors.inverseOnSurface}
    >
      <Typography variant="titleSmall">Note Preview</Typography>
      <Typography variant="bodyMedium" color={themeColors.onSurfaceVariant}>
        {preview}
      </Typography>
    </FlexContainer>
  );
};

export default NotePreviewCard;
